<template>
  <ZMainPage type="card">
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">基础信息</span>
      </div>
      <LineWrapper list column="3" label-width="160rem">
        <LineItem v-for="item in list1" :key="item.label" :label="item.label">
          <span>{{ item.value }}</span>
          <span class="text-primary ml-1 c-p" v-if="item.button" @click="visible=true">{{ item.button }}</span>
        </LineItem>
        <image-viewer :visible.sync="visible" :list="[score_image]" />
      </LineWrapper>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">分差费缴纳信息</span>
      </div>
      <LineWrapper list column="3" label-width="160rem">
        <LineItem v-for="item in list2" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle"></LineItem>
      </LineWrapper>
      <div class="page-line"></div>
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="150rem" label-position="right">
        <template v-if="isDetail">
          <LineWrapper list column="3" label-width="160rem">
            <LineItem label="实际待缴分差费总额" :value="formData.actual_compute_fee"></LineItem>
            <LineItem label="已缴分差费总额" :value="formData.payed_compute_fee"></LineItem>
            <LineItem label="缴费时间" :value="formData.actual_payed_at"></LineItem>
            <LineItem label="备注" :value="formData.remark" v-if="formData.remark"></LineItem>
          </LineWrapper>
        </template>
        <template v-else>
          <el-form-item label="实际待缴分差费总额" prop="actual_compute_fee">
            <el-input v-model="formData.actual_compute_fee" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="已缴分差费总额" prop="payed_compute_fee">
            <el-input v-model="formData.payed_compute_fee" placeholder="请输入已缴分差费总额"></el-input>
          </el-form-item>
          <el-form-item label="缴费时间" prop="actual_payed_at">
            <el-date-picker v-model="formData.actual_payed_at" type="datetime" placeholder="请选择缴费时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="formData.remark" maxlength="300" placeholder="请输入" rows="8" show-word-limit type="textarea"></el-input>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div class="z-box-bg mb-2" v-if="isDetail">
      <div class="z-box-title">
        <span class="z-box-title-text">操作记录</span>
      </div>
      <LineWrapper list column="3">
        <LineItem class="item" v-for="item in list3" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle"></LineItem>
      </LineWrapper>
    </div>
    <template #footer>
      <template v-if="isDetail">
        <el-button type="primary" @click="$router.back()">返回</el-button>
      </template>
      <template v-else>
        <el-button :loading="loading" type="primary" @click="handleSubmit('ruleForm')">通过</el-button>
        <el-button :disabled="loading" @click="handleBack">返回</el-button>
      </template>
    </template>
  </ZMainPage>
</template>

<script>
import Dialog from '@/components/common/Dialog'
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
import ImageViewer from '@/components/common/ImageViewer'
import { formDataBackMixin } from '@/utils/mixins'
import http from '@/api'
import { validateNumber } from '@/utils/validate'
import { formatDate } from '@/utils'
export default {
  _config:{'route':[{'path':'edit','meta':{'title':'审批'}}, {'path':'detail','meta':{'title':'详情'}}]},
  components: { Dialog, LineWrapper, LineItem, ImageViewer },
  mixins: [formDataBackMixin],
  data() {
    const v1 = (_r, value, callback) => {
      if (value === '') return callback(new Error('请输入实际待缴分差费总额'))
      if (this.formData.payed_compute_fee) this.$refs.ruleForm.validateField('payed_compute_fee')
      validateNumber(value, callback, { min: 0, max: 200000, equalToMin: true, equalToMax: true })
    }
    const v2 = (_r, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入已缴分差费总额'))
      }
      const num1 = Number(this.formData.actual_compute_fee)
      const num2 = Number(value)
      if (num2 !== num1) {
        return callback(new Error('【已缴分差费总额】需等于【实际待缴分差费总额】'))
      }
      validateNumber(value, callback, { min: 0, max: 200000, equalToMin: true, equalToMax: true })
    }
    return {
      id: '',
      loading: false,
      isDetail: false,
      visible: false,
      list1: [],
      list2: [],
      list3: [],
      score_image: '',
      formData: {
        actual_compute_fee: '',
        payed_compute_fee: '',
        actual_payed_at: formatDate().fullDateTime,
        remark: ''
      },
      rules: {
        actual_compute_fee: [{ required: true, validator: v1, trigger: 'change' }],
        payed_compute_fee: [{ required: true, validator: v2, trigger: 'change' }],
        actual_payed_at: [{ required: true, message: '请选择', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getData()
    if (this.$route.path.includes('detail')) {
      this.isDetail = true
    }
  },
  methods: {
    getData() {
      const { id, order_id } = this.$route.query
      if (!id && !order_id) return
      let pam = id ? `id=${id}` : `order_id=${order_id}`
      http({ url: `/finance/order-diff-fee/show?${pam}`, pre: 'zs'}).then(res => {
        this.id = res.id
        this.score_image = res.score_image
        if (res.actual_compute_fee) {
          this.formData.actual_compute_fee = res.actual_compute_fee
        }
        const num = Number(res.payed_compute_fee)
        if (num) {
          this.formData.payed_compute_fee = res.payed_compute_fee
        }
        if (this.isDetail) {
          this.formData.actual_payed_at = res.actual_payed_at
        }
        this.formData.remark = res.remark
        this.list1 = [
          { label: '报名校区', value: res.school_name },
          { label: '入学年级', value: res.grade_name },
          { label: '入学年份', value: res.year },
          { label: '学生姓名', value: res.student_name },
          { label: '学生身份证号/护照号', value: res.student_idcard },
          { label: '招生老师', value: res.teacher_name },
          { label: '已缴学费金额', value: res.money_actual },
          { label: '缴费时间', value: res.order_pay_time },
          { label: '缴费方式', value: res.pay_mode_name },
        ]
        if (res.exam_name === '中考') {
          this.list1.push({ label: '中考成绩截图', value: res.score_image ? '' : '-', button: res.score_image ? '查看成绩截图' : '' })
        }
        this.list2 = [
          { label: '计算分差费考试名称', value: res.exam_name },
          { label: '参考城市', value: res.city_name },
          { label: '第一档录取分', value: res.first_line },
          { label: '考试总分', value: res.total_score },
          { label: '折算后考试总分', value: res.convert_score },
          { label: '系统计算待缴分差费总额', value: res.sys_compute_fee }
        ]
        this.list3 = [
          { label: '操作人', value: res.opt_username },
          { label: '操作时间', value: res.opt_at, cssStyle: {'grid-column': '2 / -1' }}
        ]
      })
    },
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = { ...this.formData }
          if (this.id) { data.id = this.id }
          this.loading = true
          http({ url: '/finance/order-diff-fee/approve', pre: 'zs', method: 'post' }, data).then(() => {
            this.$message.success(`审批成功`)
            this.$router.back()
          }).finally(() => this.loading = false)
        }
      })
    },
    handleBack() {
      this.formBack(this.formData)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-line {
  height: 1px;
  background-color: #e0e0e0;
  margin: 30rem 0;
}
</style>
